// Scripting for sliders or carousels
(function($){

	// Simple Slider Block using Slick.js
	$('.testimonial-slider .wp-block-group__inner-container').slick({
		arrows: true,
		dots: false,
		slidesToScroll: 1,
		slidesToShow: 1,
		infinite: true,
		// variableWidth: true,
		draggable: true,
		prevArrow: '<button type="button" class="slick-prev slick-arrow"><i class="fa-light fa-chevron-left"></i></button>',
		nextArrow: '<button type="button" class="slick-next slick-arrow"><i class="fa-light fa-chevron-right"></i></button>',
	});


})(jQuery);
